import ModalButton from "@/app/shared/modal-button";
import PageHeader from "@/app/shared/page-header";
import CreateRole from "@/app/shared/roles-permissions/create-role";
import RolesGrid from "@/app/shared/roles-permissions/roles-grid";
import UsersTable from "@/app/shared/roles-permissions/users-table";

const pageHeader = {
    title: "Roles and Permissions ",
    breadcrumb: [
        {
            href: "/",
            name: "Dashboard",
        },
        {
            name: "Role Management & Permission",
        },
    ],
};

export default function BlankPage() {
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <ModalButton label="Add New Role" view={<CreateRole />} />
            </PageHeader>
            <RolesGrid />
            <UsersTable />
        </>
    );
}
